import React from 'react';
import { connect } from 'react-redux';
import { useTranslations } from 'next-intl';
import PropTypes from 'prop-types';
import Button from '@components/atoms/button/button';
import Headline from '@components/atoms/headline/headline';
import Image from '@components/atoms/image/image';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import Link from '@components/atoms/link/link';

import StyledTeaser from './teaser.style';

const Teaser = ({
  calendar,
  date,
  data: { headline, subline, description, bookable, image, titleImage, uri },
  queryParams,
  type
}) => {
  const t = useTranslations();
  const gomusTour = type === 'tour';

  const time = new Date(date.replace(/-/g, '/')).toLocaleTimeString('de', {
    timeStyle: 'short'
  });
  const teaserImage = image || titleImage;

  return (
    <StyledTeaser>
      <div className="teaser__meta">
        <div className="teaser__meta__time">{!gomusTour ? time : null}</div>
        <div className="teaser__meta__bookable teaser__meta__bookable--bordered">
          {gomusTour ? t('calendar.tour.forGroups') : t('calendar.tour.publicTour')}
        </div>
      </div>
      <div className="teaser__image">{teaserImage?.src && <Image {...teaserImage} />}</div>

      <div className="teaser__text">
        <Headline tag="h3" teaser>
          {headline}
        </Headline>
        <div className="teaser__copy">
          <MixedCopy html={description ?? subline} />
        </div>
      </div>

      <div className={`teaser__book-btn ${bookable ? 'teaser__book-btn--active' : ''}`}>
        <Link href={bookable ? `${uri}?date=${date}&${queryParams}` : null}>
          <Button disabled={!bookable}>
            {gomusTour ? t('calendar.moreTourDetails') : calendar.results.book}
          </Button>
        </Link>
      </div>
    </StyledTeaser>
  );
};

Teaser.propTypes = {
  type: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  data: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    description: PropTypes.string,
    subline: PropTypes.string,
    bookable: PropTypes.bool,
    image: PropTypes.shape(),
    titleImage: PropTypes.shape(),
    uri: PropTypes.string.isRequired
  }).isRequired,
  queryParams: PropTypes.shape(),
  calendar: PropTypes.shape().isRequired
};

const mapStateToProps = ({ app: { pageData } }) => ({
  calendar: pageData.calendar
});

export default connect(mapStateToProps)(Teaser);
